import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: boolean,
  action: ActionType<typeof config>,
): boolean {
  switch (action.type) {
    case getType(config.setPrinterless): {
      const { value } = action.payload;
      return value ?? false;
    }
    default:
      return state ?? false;
  }
}
